module.exports = __webpack_public_path__ + "img/rca-logo-white.e38a0bce.svg";